import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client/axios';

export function useVendorFeatures() {
  const query = useQuery({
    queryKey: ['vendor-features'],
    queryFn: async () => {
      const { data } = await apiClient.get('/vendor-features');

      return data;
    },
    staleTime: Infinity,
  });

  const featuresByKey = query.data?.features ?? {};

  const configurableFeatures = Object.entries(featuresByKey)
    .filter(([, policy]) => policy.configurable)
    .map(([key, policy]) => ({
      key,
      default: policy.default,
      configurable: policy.configurable,
      display_name: policy.display_name,
    }));

  const getEnabledFeatureLabels = (orgFeatures) =>
    Object.entries(orgFeatures || {})
      .filter(([key, enabled]) => enabled && featuresByKey[key])
      .map(([key]) => featuresByKey[key].display_name);

  return {
    ...query,
    featuresByKey,
    configurableFeatures,
    getEnabledFeatureLabels,
  };
}
